import { CommonModule, NgIf, UpperCasePipe } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SvgIconComponent } from '@utilities/components/svg-icon/svg-icon.component';
import { WishListService } from '../../services/wish-list.service';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ShareWishlistRequestInterface } from '../../interfaces/share-wishlist-request.interface';
import { take } from 'rxjs';
import { FormUtils } from '@utilities/classes/form-utils';
import {
  EMAIL_PATTERN,
  NAME_PATTERN,
} from '@utilities/constants/reg-exp-patterns';
import { FormErrorLabelComponent } from '../form-error-label/form-error-label.component';
import { OnlyNameDirective } from '@utilities/directives/only-name.directive';

@Component({
  selector: 'app-modal-shared',
  imports: [
    UpperCasePipe,
    SvgIconComponent,
    FormsModule,
    ReactiveFormsModule,
    NgIf,
    FormErrorLabelComponent,
    OnlyNameDirective,
  ],
  templateUrl: './modal-shared.component.html',
})
export class ModalSharedComponent {
  title = signal<string>('');
  description = signal<string>('');
  wishListId = signal<string>('');
  private fb = inject(FormBuilder);
  private wishListService = inject(WishListService);
  public ngbActiveModal = inject(NgbActiveModal);

  formUtils = FormUtils;
  form = this.fb.group({
    alias: [
      '',
      [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(80),
        Validators.pattern(NAME_PATTERN),
      ],
    ],
    email: [
      '',
      [
        Validators.email,
        Validators.minLength(10),
        Validators.maxLength(120),
        Validators.required,
        Validators.pattern(EMAIL_PATTERN),
      ],
    ],
  });

  sharedWishList() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    let request: ShareWishlistRequestInterface = {
      whishlistId: this.wishListId(),
      name: this.form.value.alias!,
      email: this.form.value.email!,
    };
    this.wishListService
      .sharedWishList(request)
      .pipe(take(1))
      .subscribe({
        next: (isSuccess) => {
          this.ngbActiveModal.close(isSuccess);
        },
        error: () => {
          this.ngbActiveModal.dismiss('error');
        },
      });
  }
}
